import * as React from 'react';
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';
import { useSafeRedirectPath } from '../hooks/useSafeRedirectPath';

interface ProtectedRouteProps {
  children: ReactNode;
}

export const UnprotectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated } = useAuth();
  const redirectTo = useSafeRedirectPath();

  if (isAuthenticated) {
    return <Navigate to={redirectTo} />;
  }
  return children;
};
